import { Injectable } from '@angular/core';

@Injectable()
export class BazaDataAccessConfig {
    apiEndpointUrl: string;
}
